import React from 'react';

const benefitsData = [
    {
        title: '$19/month',
        subtitle: 'Pricing - for Life',
    },
    {
        title: 'Lifetime',
        subtitle: 'Referral Commissions',
    },
    {
        title: 'Be First in Line',
        subtitle: 'Before we scale nationwide',
    },
];

const Section_1 = () => {
    return (
        <section id="section1" className="bg-white p-4 sm:p-6">
            <div className="max-w-7xl mx-auto">
                <div
                    className="rounded-3xl text-white text-center py-12 px-6 sm:py-16 sm:px-8
    bg-[radial-gradient(circle_at_50%_0%,theme(colors.sky.300),theme(colors.blue.500))]"
                >

                    <h2 className="text-3xl sm:text-4xl font-bold tracking-tight">
                        Why the First 500 Agents Matter
                    </h2>

                    <p className="mt-3 text-lg text-white/80 max-w-2xl mx-auto">
                        This isn't "early access" — this is founder-level status
                    </p>

                    <div className="mt-12 flex flex-col items-center gap-y-8 lg:flex-row lg:justify-center lg:gap-x-12">
                        {benefitsData.map((benefit, index) => (
                            <React.Fragment key={index}>
                                <div>
                                    <p className="text-2xl sm:text-3xl font-semibold">{benefit.title}</p>
                                    <p className="mt-1 text-sm text-white/70">{benefit.subtitle}</p>
                                </div>

                                {index < benefitsData.length - 1 && (
                                    <div className="w-px h-16 bg-white/25 lg:h-20"></div>
                                )}

                            </React.Fragment>
                        ))}
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Section_1;